import axios from "axios";
import { servicePath } from 'constants/defaultValues';
import { getAccessToken } from 'helpers/Firebase';
import moment from 'moment';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
    deleteIssuesTypesListError, deleteIssuesTypesListSuccess,

    getIssuesTypesListError,
    getIssuesTypesListSuccess
} from './actions';
import {
    ISSUES_TYPES_DELETE_ITEMS, ISSUES_TYPES_GET_LIST, ISSUES_TYPES_INITIALIZE_LIST
} from './actions_def';


const apiUrl = servicePath;

const initializeIssuesTypesListRequest = async (payload) => {
    // console.log(payload);
    // eslint-disable-next-line no-return-await
    return await new Promise((success) => {
        const instance = axios.create({
            method: 'get',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });
        instance.get('/projects/' + payload.projectId + '/issuetypes/initialize',
            { crossdomain: true })
            .then(response => success(response.data ?
                response.data.map(item => item)
                :
                []));
    })
        .then((response) => response)
        .catch((error) => error);
};

function* initializeIssuesTypesList({ payload }) {
    // // console.log(payload);;
    if (!payload) {
        yield put(getIssuesTypesListError({ error: 'prerequisites' }));
    }
    else {
        try {
            const response = yield call(initializeIssuesTypesListRequest, payload);
            yield put(getIssuesTypesListSuccess(response));
        } catch (error) {
            yield put(getIssuesTypesListError(error));
        }
    }
}

const getIssuesTypesListRequest = async (payload) => {
    // console.log(payload);
    // eslint-disable-next-line no-return-await
    return await new Promise((success) => {
        const instance = axios.create({
            method: 'get',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });
        instance.get('/projects/' + payload.projectId + '/issuetypes/',
            { crossdomain: true })
            .then(response => success(response.data ?
                response.data.map(item => item)
                :
                []));
    })
        .then((response) => response)
        .catch((error) => error);
};

function* getIssuesTypesList({ payload }) {
    // // console.log(payload);;

    if (!payload) {
        yield put(getIssuesTypesListError({ error: 'prerequisites' }));
    }
    else {
        try {
            const response = yield call(getIssuesTypesListRequest, payload);
            yield put(getIssuesTypesListSuccess(response));
        } catch (error) {
            yield put(getIssuesTypesListError(error));
        }
    }
}


const deleteIssuesTypesListRequest = async (items) => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success, fail) => {

        // success(notificationListData.data);
        // var _user = JSON.parse(localStorage.getItem("user"));
        const instance = axios.create({
            method: 'delete',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });

        // console.log('Sending :', {
        //   rfc_title: item.title,
        //   rfc_type: item.type ? item.type : 1,
        //   rfc_summary: item.detail ? item.detail : ' ',
        // })
        let _type = 1;
        switch (items.type) {
            case "PENDING": _type = 1; break;
            default: _type = 1;
        };

        items.map(item => {
            console.log(item)
            instance.delete('/issuetypes/' + item + '/',
                { crossdomain: true })
                .then(response => {
                    if (response.data) {
                        if (response.data.type === "fail") {
                            fail(response.data);
                        }
                        else if (response.data.type === "success" || response.data.type === "ok") {
                            success(response.data);
                        }
                        else {
                            console.log('Inconsistent behaviour', response.data.type)
                        }
                    }
                }).catch((error) => {
                    console.log(error)
                });
        });
    })
        .then((response) => response)
        .catch((error) => error);
};

function* deleteIssuesTypesList({ payload }) {
    // // console.log(payload);;

    try {
        const response = yield call(deleteIssuesTypesListRequest, payload);
        yield put(deleteIssuesTypesListSuccess(response));
    } catch (error) {
        yield put(deleteIssuesTypesListError(error));
    }
}



export function* watchGetList() {
    yield takeEvery(ISSUES_TYPES_GET_LIST, getIssuesTypesList);
}

export function* watchInitializeList() {
    yield takeEvery(ISSUES_TYPES_INITIALIZE_LIST, initializeIssuesTypesList);
}

export function* watchDeleteItems() {
    yield takeEvery(ISSUES_TYPES_DELETE_ITEMS, deleteIssuesTypesList);
}

export default function* rootSaga() {
    yield all([
        fork(watchGetList),
        fork(watchInitializeList),
        fork(watchDeleteItems),
    ]);
}
